import fr from "./fr.json";
import de from "./de.json";
import uk from "./uk.json";
import it from "./it.json";

const currentLocale = process.env.GATSBY_COUNTRY || "de";

const languages = {
  "fr": fr,
  "de": de,
  "uk": uk,
  "it": it
};

const locale = languages[currentLocale];

export default locale;
